/** Apply company-info metadata. Name only — never persist remote logo URLs. */
export default function applyCompanyInfoFromFetch({ info, values, touched, setFieldValue }) {
  if (!touched.name || !values.name) {
    setFieldValue('name', info.companyName);
  }
  return info;
}
